import { useTranslation } from "react-i18next";
import styles from "./DisponibiliteButton.module.scss";

type Props = {
  label: string;
  value: string;
  disponibilitesFilter: string[];
  weeklist: number;
  setDisponibilitesFilter: React.Dispatch<React.SetStateAction<string[]>>;
};

export default function DisponibiliteButton(props: Props) {
  const { t } = useTranslation();
  const { label, value, disponibilitesFilter, setDisponibilitesFilter, weeklist } = props;

  const getTranslatedDate = (dateStr: string) => {
    const [day, month] = dateStr.split(" ");
    const monthMap: { [key: string]: string } = {
      "juin": t("calendarDropdown.months.june"),
      "juillet": t("calendarDropdown.months.july")
    };
    return `${day} ${monthMap[month] || month}`;
  };

  function handleClick() {
    if (disponibilitesFilter.includes(value)) {
      setDisponibilitesFilter(
        disponibilitesFilter.filter((disponibilite) => disponibilite !== value)
      );
    } else {
      setDisponibilitesFilter([...disponibilitesFilter, value]);
    }
  }

  return (
    <button
      type="button"
      className={styles.disponibiliteButton}
      is-selected={
        disponibilitesFilter.includes(value) ? "selected" : "unselected"
      }
      onClick={handleClick}
    >
      {getTranslatedDate(label)}
    </button>
  );
}
